/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_BACKGROUND_FILE',
  PUT: 'UPDATE_BACKGROUND_FILE',
  DELETE: 'DELETE_BACKGROUND_FILE',
  RESET: 'RESET_VIDEO_CONTENT_MAIN_PANEL',
};

export const getDraftId = () => (`backgroundFile-draft${new Date().valueOf()}`);

export const backgroundFileReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      const id = action.payload.id ? action.payload.id : getDraftId();
      return [
        ...state,
        { ...action.payload, id },
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.findIndex((x) => x.id == action.index);
      newValues.splice(index, 1);
      return newValues;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
